import { Fragment } from "react";
import { escapeRegExp } from "@/lib/Utils/escapeRegExp";

export function getSearchTokens(search: string): string[] {
  return search
    .trim()
    .split(/\s+/)
    .filter((token) => token.length > 0);
}

export function matchesAnyToken(
  text: string | null | undefined,
  tokens: string[],
): boolean {
  if (!text || tokens.length === 0) {
    return false;
  }
  const lower = text.toLowerCase();
  return tokens.some((token) => lower.includes(token.toLowerCase()));
}

type HighlightedTextProps = {
  text: string | null | undefined;
  tokens: string[];
};

export function HighlightedText({ text, tokens }: HighlightedTextProps) {
  if (!text) {
    return null;
  }
  if (tokens.length === 0) {
    return <>{text}</>;
  }

  const pattern = new RegExp(`(${tokens.map(escapeRegExp).join("|")})`, "gi");
  const parts = text.split(pattern);

  return (
    <>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <mark
            key={index}
            className="rounded bg-yellow-200 px-0.5 text-gray-900"
          >
            {part}
          </mark>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        ),
      )}
    </>
  );
}
